import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import SearchForm from '../../ClinicalManagement/SearchForm';
import DataAnalyticsTable from './DataAnalyticsTable';
import { useDispatch } from 'react-redux';
import { resetAndrologyData } from '../../../../actions/andrologyAction';
export default function AndrologySearchBar({ patientDataHandler }) {
  const [activeTab, setActiveTab] = useState(1);

  const dispatch = useDispatch();
  return (
    <div className="card clinical-landing">
      <ul
        className="nav nav-tabs"
        role="tablist"
        style={{
          background: '#ffff',
        }}
      >
        <li
          className={`nav-item mr-1 ${activeTab === 1 ? 'active' : ''}`}
          onClick={() => setActiveTab(1)}
        >
          <Link
            to="#"
            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
          >
            Search Patient
          </Link>
        </li>
        <li
          className={`nav-item mr-1 ${activeTab === 2 ? 'active' : ''}`}
          onClick={() => {
            
            setActiveTab(2)
            dispatch(resetAndrologyData())
            }}
        >
          <Link
            to="#"
            className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
          >
            Data Analytics
          </Link>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab === 1 && (
          <div className="tab-pane show active">
            <SearchForm
              andrology={true}
              patientDataHandler={patientDataHandler}
            />
          </div>
        )}
        {activeTab === 2 && (
          <div className="tab-pane show active">
            <DataAnalyticsTable />
          </div>
        )}
      </div>
    </div>
  );
}
